export const selectors = {
  // States
  hover: '&:hover',
  focus: "&:focus-visible, &:has(:focus-visible), &[data-focus-visible='true']",

  // Browsers
  safari: `@supports (font: -apple-system-body) and (-webkit-appearance: none)`,
};
